/* ===== Electro Early Black Friday Apple Watch giveaway (Jose 2026-10-21) =====
   Theme copy 2026-10-24 (bfwatch-1022/build.mjs): final handoff file (8-Pack only, retry, rules pop-up) + /cart/change without .js.
   Load in <head>, before the cart drawer script, so it sees the first cart fetch.
   Every placement reads window.ELECTRO_BF. Set on:false and nothing renders.
   It never changes what is in the cart. It only adds a hidden cart attribute
   (_bf_giveaway) so entries can be pulled from orders and the confirmation
   email can say "You're entered". */
(function(){
  "use strict";
  var BF = window.ELECTRO_BF = Object.assign({
    on: true,
    label: "Early Black Friday",
    draw: "Dec 1",
    start: "Oct 22", ends: "Nov 27", notify: "Dec 5", year: "2026",
    host: "ElectroGum LLC, Miami, FL",
    drawnBy: "Verified third-party draw service",   /* "" hides the row */
    winners: 10,
    value: 399,
    pack: "8",                               /* widget data-pack that enters */
    offStyle: "headline",                    /* refills off: "hide" | "headline" | "card" */
    entryVariants: [51019548229884],  /* 8-Pack, subscription only */
    img: "",
    rules: "/pages/apple-watch-giveaway",
    attr: "_bf_giveaway",
    attrValue: "apple-watch-bf-2026"
  }, window.ELECTRO_BF || {});
  if (!BF.on) return;

  var GIFT = '<span class="bfw-emoji" aria-hidden="true">\uD83C\uDF81</span>';
  var BOLT = '<svg class="bfw-bolt" viewBox="0 0 24 24" aria-hidden="true"><path d="M13 2L4 14h7l-1 8 9-12h-7z"/></svg>';
  var LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  function fine(){ return '<div class="bfw-fine">' + BF.winners + ' winners drawn ' + BF.draw + '. <a href="' + BF.rules + '" data-bfw-rules>Official rules</a></div>'; }

  /* ---------- cart: watch every cart response, no extra requests ---------- */
  var lastCart = null, cartSubs = [];
  function isCart(j){ return j && typeof j === "object" && Array.isArray(j.items) && ("item_count" in j || "token" in j || "total_price" in j); }
  function onCart(fn){ cartSubs.push(fn); if (lastCart) fn(lastCart); }
  function gotCart(c){ lastCart = c; cartSubs.forEach(function(fn){ try { fn(c); } catch(e){} }); }
  var realFetch = window.fetch;
  if (realFetch) window.fetch = function(input){
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var p = realFetch.apply(this, arguments);
    if (/\/cart(\.js|\/(add|change|update|clear)(\.js)?)(\?|$)/.test(url)) {
      p.then(function(r){ return r.clone().json(); }).then(function(j){ if (isCart(j)) gotCart(j); }).catch(function(){});
    }
    return p;
  };
  function lineIsSub(li){ return !!(li && li.selling_plan_allocation && li.selling_plan_allocation.selling_plan); }
  function entered(c){ return !!(c && c.items && c.items.some(function(li){ return lineIsSub(li) && BF.entryVariants.indexOf(li.variant_id) !== -1; })); }

  /* Hidden cart attribute, only written when it changes.
     On the real store the merch test, the free-gift engine and the drawer hit the cart in the same
     second as this write, and Shopify answers some of those calls with 429. So a write can fail, and
     carts seen while it is in flight are skipped. After every write (ok or not) one /cart.js re-check
     runs ~1s after the last cart response and writes again if the cart still disagrees
     (at most 4 writes per wanted value, so a store that keeps refusing is not hammered). */
  var writing = false, goal = null, tries = 0, recheck = null, checks = 0;
  function verify(ms){
    clearTimeout(recheck);
    recheck = setTimeout(function(){
      recheck = null;
      realFetch("/cart.js", {credentials:"same-origin", headers:{Accept:"application/json"}})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(j){ if (isCart(j)) gotCart(j); else if (++checks < 3) verify(2000); })
        .catch(function(){ if (++checks < 3) verify(2000); });
    }, ms || 1000);
  }
  onCart(function(c){
    var want = entered(c) ? BF.attrValue : "";
    var have = (c.attributes && c.attributes[BF.attr]) || "";
    if (recheck) verify();                              /* cart still moving: push the re-check back */
    if (want === have) { tries = 0; return; }
    if (!c.items.length && !have) return;
    if (want !== goal) { goal = want; tries = 0; }
    if (writing || tries >= 4) return;
    tries++; writing = true; checks = 0;
    var attrs = {}; attrs[BF.attr] = want;
    realFetch("/cart/update.js", {method:"POST", credentials:"same-origin", headers:{"Content-Type":"application/json", Accept:"application/json"}, body: JSON.stringify({attributes: attrs})})
      .then(function(r){ return r.ok ? r.json() : null; }).then(function(j){ if (isCart(j)) lastCart = j; }).catch(function(){})
      .then(function(){ writing = false; verify(); });
  });


  /* ---------- 7. Official rules popup (every "Official rules" link with data-bfw-rules) ---------- */
  var pop = null, popLast = null;
  function popupHTML(){
    var img = BF.img ? '<img src="' + BF.img + '" alt="" width="300" height="300">' : "";
    return '<div class="bfwg-scrim" data-bfwg-close></div>' +
      '<div class="bfwg" role="dialog" aria-modal="true" aria-labelledby="bfwg-t">' +
      '<button class="bfwg-x" type="button" aria-label="Close" data-bfwg-close>✕</button>' +
      '<div class="bfwg-hero"><div class="bfwg-img">' + img + '</div><div><div class="bfwg-k">' + BF.label + ' Giveaway</div><div class="bfwg-t" id="bfwg-t">Win an Apple Watch</div></div></div>' +
      '<div class="bfwg-body"><div class="bfwg-facts">' +
        '<div class="bfwg-fact"><span>Prize</span><b>Apple Watch</b><small>$' + BF.value + ' value</small></div>' +
        '<div class="bfwg-fact"><span>Winners</span><b>' + BF.winners + '</b></div>' +
        '<div class="bfwg-fact"><span>Enter by</span><b>' + BF.ends + '</b></div>' +
        '<div class="bfwg-fact"><span>Draw</span><b>' + BF.draw + '</b></div></div>' +
      '<p class="bfwg-h">How to enter</p><ol class="bfwg-steps">' +
        '<li><i>1</i><span><b>Subscribe to the ' + BF.pack + '-Pack.</b> You’re entered automatically with the name and email on your order.</span></li>' +
        '<li><i>2</i><span><b>One entry per person.</b> ' + BF.winners + ' winners are drawn at random on ' + BF.draw + '.</span></li>' +
        '<li><i>3</i><span><b>Winners get an email</b> by ' + BF.notify + '.</span></li></ol>' +
      '<div class="bfwg-cert"><div class="bfwg-cert-h"><span class="bfwg-seal"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l2.4 1.8 3-.2.9 2.9 2.5 1.7-1 2.8 1 2.8-2.5 1.7-.9 2.9-3-.2L12 22l-2.4-1.8-3 .2-.9-2.9-2.5-1.7 1-2.8-1-2.8 2.5-1.7.9-2.9 3 .2z" fill="currentColor"/><path d="M8.5 12.2l2.3 2.3 4.7-4.9" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span><b>Official random draw</b></div><dl>' +
        '<dt>Hosted by</dt><dd>' + BF.host + '</dd>' +
        '<dt>Entries</dt><dd>' + BF.start + ' to ' + BF.ends + ', ' + BF.year + '</dd>' +
        '<dt>Draw</dt><dd>' + BF.draw + ', ' + BF.year + ' · ' + BF.winners + ' winners</dd>' +
        (BF.drawnBy ? '<dt>Drawn by</dt><dd>' + BF.drawnBy + '</dd>' : '') + '</dl></div>' +
      '<p class="bfwg-small">Open to US residents 18 and over (excludes Rhode Island). Odds depend on the number of entries. Apple is not a sponsor of this giveaway. <a href="' + BF.rules + '" target="_blank" rel="noopener">Official rules</a></p>' +
      '<details class="bfwg-full"><summary>Read the full official rules</summary><div class="bfwg-legal">' +
        '<h5>Sponsor</h5><p>' + BF.host.replace(", FL", ", Florida") + '. contact@electrogum.com</p>' +
        '<h5>Giveaway period</h5><p>' + BF.start + ', ' + BF.year + ', 12:00 AM ET through ' + BF.ends + ', ' + BF.year + ', 11:59 PM ET.</p>' +
        '<h5>Eligibility</h5><p>Legal residents of the 50 US states and DC, excluding Rhode Island, 18 or older. Sponsor employees and their households can’t enter.</p>' +
        '<h5>Entry</h5><p>A subscription order for an Electro Gum ' + BF.pack + '-Pack during the giveaway period enters you automatically. One entry per person. Other ways to enter and all terms are in the complete rules.</p>' +
        '<h5>Prizes</h5><p>' + BF.winners + ' Apple Watches (or a comparable smartwatch of equal or greater value), approximate retail value $' + BF.value + ' each.</p>' +
        '<h5>Drawing</h5><p>Random drawing on or about ' + BF.draw + ', ' + BF.year + ' from all eligible entries. Winners are notified by email around ' + BF.notify + ' and have 7 days to reply.</p>' +
        '<p style="margin-top:10px"><a href="' + BF.rules + '" target="_blank" rel="noopener">See the complete official rules →</a></p>' +
      '</div></details><button class="bfwg-cta" type="button" data-bfwg-close>Got it</button></div></div>';
  }
  function openRules(){
    if (!pop) { pop = document.createElement("div"); pop.className = "bfwg-root"; pop.innerHTML = popupHTML(); document.body.appendChild(pop); }
    popLast = document.activeElement;
    pop.querySelector(".bfwg-scrim").classList.add("is-open"); pop.querySelector(".bfwg").classList.add("is-open");
    document.documentElement.style.overflow = "hidden";
    setTimeout(function(){ var x = pop.querySelector(".bfwg-x"); if (x) x.focus(); }, 60);
  }
  function closeRules(){
    if (!pop) return;
    pop.querySelector(".bfwg-scrim").classList.remove("is-open"); pop.querySelector(".bfwg").classList.remove("is-open");
    document.documentElement.style.overflow = ""; if (popLast && popLast.focus) popLast.focus();
  }
  document.addEventListener("click", function(e){
    if (e.target.closest && e.target.closest("[data-bfw-rules]")) { e.preventDefault(); e.stopPropagation(); openRules(); }
    else if (pop && e.target.closest && e.target.closest("[data-bfwg-close]")) closeRules();
  }, true);
  document.addEventListener("keydown", function(e){ if (e.key === "Escape") closeRules(); });

  function ready(fn){ if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn); else fn(); }
  ready(function(){
    var IMG = BF.img;

    /* ---------- 4. sticky bar (homepage + product page) ----------
       Keep the live "+ up to 3 free gifts" chip and add the giveaway after it.
       The creator page sticky ("+ 3 free gifts / Save 48%" button) is left alone. */
    var sg = document.querySelector(".ah-stk-gift");
    if (sg && !sg.querySelector(".bfw-stk-w")) {
      sg.classList.add("bfw-stk");
      /* desktop: inside the chip, after "+ up to 3 free gifts". Phones: its own line under the chip. */
      sg.insertAdjacentHTML("beforeend", '<em class="bfw-stk-w">+ Apple Watch giveaway</em>');
      sg.insertAdjacentHTML("afterend", '<em class="bfw-stk-m">' + BOLT + 'Apple Watch giveaway</em>');
    }

    /* ---------- 5. final CTA: add a pill, keep the page's own line ---------- */
    var fs = document.querySelector(".ah-fin-sub");
    if (fs && !fs.querySelector(".bfw-fin")) fs.insertAdjacentHTML("beforeend", ' <span class="bfw-fin">' + GIFT + "Win an Apple Watch</span>");

    /* ---------- 3. widget ---------- */
    var root = document.getElementById("ew2-root");
    if (root) widget(root, IMG);

    /* ---------- 6. cart drawer ---------- */
    var scroll = document.getElementById("ecd-scroll") || document.getElementById("ecd");
    if (scroll) {
      var paint = function(){ drawer(scroll, IMG); };
      new MutationObserver(function(){ if (!scroll.__bfw) { scroll.__bfw = true; requestAnimationFrame(function(){ scroll.__bfw = false; paint(); }); } }).observe(scroll, {childList:true, subtree:true});
      onCart(paint);
    }
  });

  function widget(root, IMG){
    var strip = document.getElementById("ew2-strip"), tiles = document.getElementById("ew2-tiles"), opts = document.getElementById("ew2-options");
    /* Subscribe box line */
    var subLine = root.querySelector('.op-tab[data-sub="1"] .op-tab-s');
    if (subLine) subLine.textContent = "Free gifts + giveaway";

    var card = null, nudge = null, wasOn = null;
    function state(){ return {pack: root.getAttribute("data-pack") || "", mode: root.getAttribute("data-mode") || ""}; }
    /* The black badge only belongs to the subscription offer. Refills off / One-time: the row's own badge comes back. */
    function badge(){
      if (!opts) return;
      var row = opts.querySelector('.ew2-option[data-size="' + BF.pack + '"] .ew2-badge');
      if (!row) return;
      var sub = state().mode === "sub", is = row.classList.contains("bfw-badge");
      if (sub && !is) { row.__bfwOrig = {h: row.innerHTML, c: row.className}; row.classList.add("bfw-badge"); row.innerHTML = BOLT + BF.label; }
      else if (!sub && is && row.__bfwOrig) { row.className = row.__bfwOrig.c; row.innerHTML = row.__bfwOrig.h; }
    }
    function paint(){
      var s = state(), on = s.pack === BF.pack;
      badge();
      /* prize card: lives in the strip, so it hides with the gifts on One-time and Trial */
      if (strip && tiles) {
        if (!card) { card = document.createElement("div"); tiles.insertAdjacentElement("afterend", card); card.insertAdjacentHTML("afterend", fine()); }
        if (on !== wasOn) {
          var tag = on ? '<span class="bfw-tag is-in">' + CHECK + "You're in</span>"
                       : '<button type="button" class="bfw-tag is-lock" data-bfw-pick>' + LOCK + BF.pack + "-Pack only</button>";
          card.className = "bfw-card" + (on ? " is-on bfw-shine" : "") + (on && wasOn === false ? " is-pop" : "");
          card.innerHTML = '<div class="bfw-row"><div class="bfw-img">' + (IMG ? '<img src="' + IMG + '" alt="Apple Watch" width="300" height="300">' : "") + "</div>" +
            '<div class="bfw-txt"><div class="bfw-k">' + BF.label + ' Giveaway</div><div class="bfw-t">Win an Apple Watch</div>' +
            '<div class="bfw-v"><b>$' + BF.value + " value</b><span>" + (on ? "Automatically added to the draw" : "Free entry with the " + BF.pack + "-Pack") + "</span></div>" +
            '<div class="bfw-mtag">' + tag + "</div></div>" + tag + "</div>";
          wasOn = on;
        }
      }
      /* Refills off / One-time on the 8-Pack. BF.offStyle: "hide" (nothing), "headline" (in the Keep deal
         headline, homepage gets the nudge), "card" (a locked giveaway card that turns refills back on). */
      var off = s.mode === "onetime" && on, style = BF.offStyle || "headline";
      var wb = document.getElementById("ew2-winback");
      if (wb) {
        var wtl = wb.querySelector(".ew2-wb-title"), has = wb.querySelector(".bfw-wbw");
        if (wtl && off && style === "headline" && !has) { wtl.classList.add("bfw-wrap"); wtl.insertAdjacentHTML("beforeend", '<span class="bfw-wbw">+ Apple Watch entry</span>'); }
        else if (has && (!off || style !== "headline")) { has.remove(); if (wtl) wtl.classList.remove("bfw-wrap"); }
      }
      var tabs = !!root.querySelector(".op-tab");
      /* Homepage (tabs widget) gets nothing extra on One-time (Jose 2026-10-22). */
      var showNudge = off && style === "card" && !tabs;
      if (showNudge && !nudge) {
        nudge = document.createElement("button"); nudge.type = "button"; nudge.className = "bfw-nudge"; nudge.setAttribute("data-bfw-sub", "");
        nudge.innerHTML = (IMG ? '<img src="' + IMG + '" alt="" width="72" height="72">' : "") +
          "<span><b>" + BF.label + " Giveaway</b>" + (tabs ? "Subscribe" : "Turn on refills") + " for free gifts + an entry to win an Apple Watch</span><i>" + LOCK + (tabs ? "Subscribe" : "Turn on") + "</i>";
        var anchor = tabs ? opts : (document.getElementById("ew2-winback") || document.getElementById("ew2-toggle"));
        if (anchor) anchor.insertAdjacentElement("afterend", nudge);
      }
      if (nudge) nudge.hidden = !showNudge;
    }
    root.addEventListener("click", function(e){
      if (e.target.closest("[data-bfw-pick]")) { var r = opts && opts.querySelector('.ew2-option[data-size="' + BF.pack + '"]'); if (r) r.click(); }
      if (e.target.closest("[data-bfw-sub]")) { var t = root.querySelector('.op-tab[data-sub="1"]') || document.getElementById("ew2-toggle"); if (t) t.click(); }
    });
    new MutationObserver(paint).observe(root, {attributes:true, attributeFilter:["data-pack","data-mode"]});
    var wbEl = document.getElementById("ew2-winback");
    if (wbEl) new MutationObserver(function(){ if (!wbEl.querySelector(".bfw-wbw") && state().pack === BF.pack && state().mode === "onetime") paint(); }).observe(wbEl, {childList:true, subtree:true});
    if (opts) new MutationObserver(badge).observe(opts, {childList:true});
    paint();
  }

  function drawer(scroll, IMG){
    var c = lastCart; if (!c) return;
    var gc = scroll.querySelector(".ecd-gc");
    var has = gc && gc.querySelector(".bfw-gr");
    if (gc && entered(c) && !has) {
      gc.insertAdjacentHTML("beforeend", '<div class="ecd-gr bfw-gr">' + (IMG ? '<img src="' + IMG + '" alt="" loading="lazy">' : '<i class="ph"></i>') +
        "<span><small>" + BF.label.toUpperCase() + "</small><b>Apple Watch giveaway</b></span><em>" + CHECK + "ENTERED</em></div>");
    } else if (has && !entered(c)) { has.remove(); }
    /* "Upgrade to the 8 Pack" box: say the upgrade also enters the draw */
    scroll.querySelectorAll("[data-upgrade]").forEach(function(btn){
      if (BF.entryVariants.indexOf(parseInt(btn.getAttribute("data-upgrade"), 10)) === -1) return;
      var box = btn.closest(".ecd-up") || btn.parentElement;
      if (!box || box.querySelector(".bfw-upl")) return;
      /* same row style as the box's own checklist, with a bolt for the check */
      var ul = box.querySelector("ul");
      if (ul) ul.insertAdjacentHTML("beforeend", '<li class="bfw-upl"><svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true"><path fill="#C9971F" d="M13 2L4 14h7l-1 8 9-12h-7z"/></svg> Plus an entry to win an Apple Watch</li>');
      else btn.insertAdjacentHTML("beforebegin", '<div class="bfw-upl">' + BOLT + "Plus an entry to win an Apple Watch</div>");
    });
  }
})();
